import type {
  ClientEntitiesSelectedOptions,
  ClientEntityMetaData,
  ClientEntityPayloadBody,
  Criterias,
} from '@psw/shared';

export function removeOutdatedValues(
  clientEntitiesOptions: ClientEntitiesSelectedOptions = {},
  formValues: ClientEntitiesSelectedOptions = {},
): ClientEntitiesSelectedOptions {
  return Object.entries(formValues).reduce((acc, [inputName, inputOptions]) => {
    const selectedIds = inputOptions?.map(option => option?.id) || [];
    const filteredOptions = clientEntitiesOptions[inputName]?.filter(option => selectedIds?.includes(option.id)) || [];
    return {
      // TODO: fix
      // biome-ignore lint/performance/noAccumulatingSpread: <explanation>
      ...acc,
      [inputName]: filteredOptions,
    };
  }, {} as ClientEntitiesSelectedOptions);
}

export function formatValues(values: ClientEntitiesSelectedOptions = {}): ClientEntityPayloadBody {
  return Object.entries(values).reduce((acc, [key, ClientEntitiesSelectedOptions]) => {
    if (!(key in acc)) {
      acc[key] = [];
    }
    acc[key] = ClientEntitiesSelectedOptions?.map(op => op.id) || [];
    return acc;
  }, {} as ClientEntityPayloadBody);
}

export function computeClientEntitiesAttributes(
  clientEntities: ClientEntitiesSelectedOptions,
  clientEntityMetaData: ClientEntityMetaData,
) {
  return Object.entries(clientEntities).reduce((acc, [key, values]) => {
    const attrKey = clientEntityMetaData?.[key]?.id!;
    if (!attrKey || !values?.length) return acc;
    return {
      // TODO: fix
      // biome-ignore lint/performance/noAccumulatingSpread: <explanation>
      ...acc,
      [`Attributes/${attrKey}`]: values?.map(v => v.id),
    };
  }, {});
}

export function getClientEntityKeysIds(clientEntityMetaData: ClientEntityMetaData): string[] {
  return Object.values(clientEntityMetaData || {})?.map(item => item?.id);
}

export function getClientEntityName(id: string, clientEntityMetaData: ClientEntityMetaData): string {
  return Object.entries(clientEntityMetaData || {})?.reduce((acc, [k, item]) => {
    if (!acc && item?.id === id) return k;
    return acc;
  }, '');
}

export function extractClientEntityFromCriterias(
  criterias: Criterias,
  clientEntityMetaData: ClientEntityMetaData = {},
): ClientEntitiesSelectedOptions {
  return getClientEntityKeysIds(clientEntityMetaData!)
    ?.filter(id => `Attributes/${id}` in criterias)
    ?.reduce(
      (acc, id) => ({
        // TODO: fix
        // biome-ignore lint/performance/noAccumulatingSpread: <explanation>
        ...acc,
        [getClientEntityName(id, clientEntityMetaData!)]: criterias[`Attributes/${id}`]?.map(id => ({
          id: `${id}`,
          value: '',
        })),
      }),
      {},
    );
}
